import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DeleteToken } from '../../auth/Auth';
import Loader from '../Loader';
import serverClient from '../../api/ServerClient';
import { useLanguage } from '../../context/LanguageContext';

function DeleteCardModals({ cardId, onCardDelete }) {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        try {
            setError(null);
            setLoading(true);
            await serverClient.delete(`/api/user/card/${cardId}`);
            onCardDelete();
        } catch (e) {
            if (e.response?.status === 401) {
                DeleteToken();
                setError(t('userNotAuthorized'));
                navigate('/login');
            } else {
                setError(t('somethingWentWrong'));
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setError(error);
    }, [error]);

    return (
        <>
            <Loader loading={loading} />

            <div className="modal error-modal fade" id="delete" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="error-img">
                                <img
                                    className="img-fluid"
                                    src={'/assets/images/svg/delete.svg'}
                                    alt="delete"
                                />
                            </div>
                            <h3>{t('deleteCardConfirm')}</h3>
                            <Link
                                to="#"
                                onClick={handleDelete}
                                className="btn theme-btn successfully w-100"
                                data-bs-toggle="modal"
                                data-bs-target="#done-delete"
                            >
                                {t('confirm')}
                            </Link>
                        </div>
                        <button type="button" className="btn close-btn" data-bs-dismiss="modal">
                            <i className="icon" data-feather="x"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div className="modal error-modal fade" id="done-delete" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h2 className="modal-title">
                                {error !== null ? t('error') : t('deletedSuccessfully')}
                            </h2>
                        </div>
                        <div className="modal-body">
                            <div className="error-img">
                                <img
                                    className="img-fluid"
                                    src={'assets/images/svg/delete.svg'}
                                    alt="delete"
                                />
                            </div>
                            <h3>{error ?? t('cardRemoved')}</h3>
                        </div>
                        <button type="button" className="btn close-btn" data-bs-dismiss="modal">
                            <i className="icon" data-feather="x"></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DeleteCardModals;
